
import React from "react";
import DataTable from "react-data-table-component";
import { achFilesJobColumns } from "./AchFilesJobColumns";
import { useState, useEffect } from "react";
import {
  Box,
} from "@mui/material";
import "../../listings/Listing.css";
import {
  createAchFile,
  getAchFileJobs,
  getachFileContent,
} from "../../common/constants/globalconstants";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { useSelector, useDispatch } from "react-redux";
import ErrorModal from "../../common/ErrorModal";
import JobRunConfirmModal from "./JobRunConfirmModal";
import {
	storeUserDetails,
  } from "../../../action";
import { useAuth0 } from "@auth0/auth0-react";
import axiosInstance from "../../common/AxiosInterceptor";
import AchFileContentModal from "./AchFileContentModal";

const customStyle = {
	table: {
	  style: {
		border: "1px solid #DEDEDE",
		borderRadius: "5px",
		justifyContent: "center",
		marginBottom: "10px",
		marginTop: "10px",
	  },
	},
	header: {
	  style: {
		color: "#193062",
	  },
	},
	headRow: {
	  style: {
		border: "none",
		backgroundColor: "#CDD4DC",
		fontWeight: "bold",
		color: "#002d82",
		fontSize: "14px",
		whiteSpace: "unset",    
    align: "center"
	  },
	},
	rows: {
	  stripedStyle: {
		backgroundColor: "#F2F3F5",
		justifyContent: "center",    
    align: "center",
    textAlign: "center"
	  },
	},
  };

function AchFilesJob() {
  const [loading, setloading] = useState(false); 
  const [achFilesJobData, setAchFilesJobData]= useState([]);
  const [errormodalopen, seterrormodalOpen]= useState(false);
  const [confrmnModalOpen, setConfrmnModalOpen]= useState(false);
  const [resetPagination, setRstPagination] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [msgDesc, setMsgDesc] = useState("");
  const [tableKey, setTableKey] = useState(0);
  const [fileContent, setFileContent] = useState("");
  const [fileName, setFileName] = useState("");
  const storetoken = useSelector((state) => state.storetoken);
  const storeuser = useSelector((state) => state.storeuser);
  const dispatch = useDispatch();
  const {user} = useAuth0();

  useEffect(()=>{
		if(storeuser== undefined || storeuser ==null || storeuser == "" ) {
		  dispatch(storeUserDetails(user));
		}
	  },[storeuser])

  useEffect(()=>{
    getAllAchFileJobs();  
  },[storeuser]);

  const getAllAchFileJobs = async() =>{
    if(storeuser!==undefined && storeuser!==null && storeuser!==""){
        setloading(true);
        try{
        const resp = await axiosInstance.get(`${getAchFileJobs}`);
          if(resp.data.isSuccess){
              setAchFilesJobData(resp.data.result);
              seterrormodalOpen(false);
          }else if(!resp.data.isSuccess){
              seterrormodalOpen(true);
          }          
          setMsgDesc(resp.data.result.message? resp.data.result.message :"");
          setloading(false);
      }
      catch(err) {
          console.log(err.message);
          seterrormodalOpen(true);
          setloading(false);
      }
    }
  }

  const onConfirmRun =() =>{
    sendReqTocreateAchFile();
  }

  const sendReqTocreateAchFile = async()=>{
      if(storeuser!== "" && storetoken !== ""){
        setloading(true);
        try{
          const response = await axiosInstance.get(`${createAchFile}?userName=${storeuser.email}`);
        
        if (response.data.isSuccess) {
            getAllAchFileJobs();            
            setTableKey(prevKey=>prevKey+1);
            seterrormodalOpen(false);
          } else if (!response.data.isSuccess) {
            seterrormodalOpen(true);
          }
          setConfrmnModalOpen(false);
          setloading(false);
        }
        catch (error) {
            console.log(error);
            seterrormodalOpen(true);
            setloading(false);
        }
      }
  }

  const onClickNo = () =>{
    setConfrmnModalOpen(false);
  }

 const handleDownlodLinkClick=(row)=>{
    getDownloadContent(row);
  }

  const getDownloadContent= async(row) =>{        
      try {
        setloading(true);
        setFileName(row.achFileName);
        const response = await axiosInstance.get(`${getachFileContent}?jobId=${row.jobId}`);
            if(response.data.isSuccess && response.data && response.data.result){
              const parsed = response.data.result.replace(/\r\n/g, '\n');
              const cleaned = parsed.replace(/\n/g, '\n');
                setFileContent(cleaned);
              }
              else if(!response.data.isSuccess){
                seterrormodalOpen(true);
              }
              setloading(false); 
        setOpenModal(true);
        setloading(false);        
    } catch (error) {
      console.log(error.message);
      seterrormodalOpen(true);
      setloading(false);
    }
  }

	  return (
		<div>
		  {loading && (
			<>
			  <Backdrop
				sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={true}
			  >
				<CircularProgress sx={{ color: "white" }} />
				<span> &nbsp;&nbsp;&nbsp;&nbsp; Loading Data... </span>
			  </Backdrop>
			</>
		  )}
	
		<div>
		  <Box
        sx={{
          position: "relative",
          alignContent:"center",
          justifyContent: "center",
          left: "2%",
		      right: "2%",
          flexDirection: "column",
          width: "95%",
          marginTop: "10px",
          marginBottom: "10px",
          alignItems: "center",
          p: "0% 1%",
          backgroundColor: "#fcfcfc",
          //border: "2px solid #dfe3e8",
          borderRadius: "20px",
        }}
      >
		  <h2 className="header">ACH Files</h2>
		  
			<DataTable
			  title=""
			  key={tableKey}
			  columns={achFilesJobColumns(handleDownlodLinkClick)}
        //columns={achFilesJobColumns}
			  data={achFilesJobData}
			  pagination
			  striped
			  highlightOnHover
			  customStyles={customStyle}
			  defaultSortFieldId={null}
			  defaultSortAsc={null}
			  paginationRowsPerPageOptions={[5, 10, 15, 20]}
			  paginationResetDefaultPage={resetPagination}
			  paginationPerPage={5}
			  paginationComponentOptions={{
				rowsPerPageText: "Records per page",
				rangeSeparatorText: "Out of",
			  }}
			/>
			
			</Box>
		  </div>
      {openModal && 
      <AchFileContentModal 
      open={openModal} 
      onClose={() => setOpenModal(false)}
      fileContent={fileContent}
      fileName={fileName}
      />}

		  {errormodalopen && (
			<ErrorModal open={true} onClose={() => seterrormodalOpen(false)} />
		  )}

        {confrmnModalOpen && (
        <JobRunConfirmModal
          open={confrmnModalOpen}
          onClose={onClickNo}
          onConfirmRun={onConfirmRun}
        />
      )}
	
		</div>
	  );
}

export default AchFilesJob;
